import { Link } from "react-router-dom";
import HeaderStats from "components/Headers/HeaderStats.js";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

export default function FileMaintainanceOverview() {
  return (
    <>
      {/* Header */}
      <HeaderStats>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Link
            to="/admin/dashboard"
            className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
          >
            DASHBOARD
          </Link>
          <ArrowForwardIosIcon
            style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
          />
          <span className="text-gray-800 text-sm uppercase hidden lg:inline-block font-semibold">
            File maintainance
          </span>
        </div>
      </HeaderStats>
      <div className="min-w-screen py-10 px-6 bg-gray-100 flex items-center justify-center bg-gray-100">
        <div className="max-w-7xl w-full mx-auto  sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row w-full lg:space-x-2 space-y-2 lg:space-y-0 mb-2 lg:mb-4">
            <Link
              to="/admin/file-maintainance/stock-categories"
              className="w-full lg:w-1/5"
            >
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-green-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-purple-500 text-white  rounded-full mr-3">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                      ></path>
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Stock Categories</div>
                    <div className="text-sm text-gray-400">categories</div>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/admin/file-maintainance/stock-items"
              className="w-full lg:w-1/5"
            >
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-blue-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-blue-400 text-white rounded-full mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Stock Items</div>
                    <div className="text-sm text-gray-400">Items</div>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/admin/file-maintainance/suppliers"
              className="w-full lg:w-1/5"
            >
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-yellow-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-yellow-500 text-white rounded-full mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Supplier File</div>
                    <div className="text-sm text-gray-400">Suppliers</div>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/admin/file-maintainance/customers"
              className="w-full lg:w-1/5"
            >
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-red-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-red-400 text-white rounded-full mr-3">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Customer File</div>
                    <div className="text-sm text-gray-400">Customers</div>
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to="/admin/file-maintainance/levies"
              className="w-full lg:w-1/5"
            >
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-green-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-green-400 text-white rounded-full mr-3">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">VAT File</div>
                    <div className="text-sm text-gray-400">Levies</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="flex flex-col lg:flex-row w-full lg:space-x-2 space-y-2 lg:space-y-0 mb-2 lg:mb-4">
            <div className="w-full lg:w-1/5">
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-green-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-yellow-500 text-white  rounded-full mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Store File</div>
                    <div className="text-sm text-gray-400">stores</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/5">
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-blue-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-red-400 text-white rounded-full mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Store Location File</div>
                    <div className="text-sm text-gray-400">Store Locations</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/5">
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-yellow-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-blue-400 text-white rounded-full mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Unit File</div>
                    <div className="text-sm text-gray-400">Units</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/5">
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-red-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-yellow-500 text-white rounded-full mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Cost Center</div>
                    <div className="text-sm text-gray-400">Cost Centers</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/5">
              <div className="widget w-full p-4 rounded-lg bg-white border-l-4 border-green-400">
                <div className="flex items-center">
                  <div className="icon w-14 p-3 bg-purple-500 text-white rounded-full mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div className="flex flex-col justify-center">
                    <div className="text-lg">Currency File</div>
                    <div className="text-sm text-gray-400">Currencies</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
